import chroma from 'chroma-js';

function ProgressBarColors(percentage) {
    const outputColorVal = chroma
        .scale(['rgb(255, 2, 0)', 'rgb(254, 146, 2)', 'rgb(255, 231, 80)', 'rgb(0, 158, 115)'])
        .domain([0, 50, 66, 100]);
    return outputColorVal(percentage).hex();
}

export default ProgressBarColors;
